import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { useErrorContext } from '@qpr/client-library';

const PREFIX = 'ErrorBanner';

const classes = {
  errorPaper: `${PREFIX}-errorPaper`,
  fixedPosition: `${PREFIX}-fixedPosition`,
  errorContainer: `${PREFIX}-errorContainer`
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.errorPaper}`]: {
    padding: theme.spacing(1),
    color: theme.palette.grey[900]
  },

  [`& .${classes.fixedPosition}`]: {
    position: 'fixed',
    width: '100%',
    zIndex: 1400
  },

  [`&.${classes.errorContainer}`]: {
    position: 'relative',
    height: '105px'
  }
}));

const ErrorBanner = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [showDetails, setShowDetails] = useState<boolean>(false);

  const { error } = useErrorContext();

  useEffect(() => {
    setIsVisible(false);
    if (error) setIsVisible(true);
  }, [error]);

  const handleOkClick = () => {
    setIsVisible(false);
  };

  const handleTellMeMoreClick = () => {
    setShowDetails(true);
  };

  const tellMeMoreButton = () => (
    <Grid item>
      <Button onClick={handleTellMeMoreClick} color="primary" disabled={showDetails}>
        Tell me more
      </Button>
    </Grid>
  );

  return (
    <Root className={classes.errorContainer} style={{ display: isVisible ? 'block' : 'none' }}>
      <div id="errorBanner" data-testid="error-banner-root" className={classes.fixedPosition}>
        <Paper elevation={0} className={classes.errorPaper}>
          <Grid container spacing={1} alignItems="center" wrap="nowrap">
            <Grid item>
              <Typography variant="body2" data-testid="error-banner-message">
                {error?.message || ''}
              </Typography>
              <Typography variant="body2" data-testid="error-banner-details">
                {showDetails ? error?.details || '' : ''}
              </Typography>
            </Grid>
          </Grid>
          <Grid container justifyContent="flex-end" spacing={2}>
            {error?.details ? tellMeMoreButton() : null}
            <Grid item>
              <Button color="primary" onClick={handleOkClick}>
                Ok
              </Button>
            </Grid>
          </Grid>
        </Paper>
        <Divider />
      </div>
    </Root>
  );
};

export default ErrorBanner;
